

import { IPagination } from '@/types';
import { Vue, Watch, Component } from 'vue-property-decorator';
import { getServiceList, addService, deleteService } from '@/api/service';
import { UserModule } from '@/store/modules/user';
import html2canvas from 'html2canvas';
var QRCode = require('qrcode');

@Component({ name: '' })
export default class extends Vue {
// --------------搜索--------------
  private formSearch: object = {
    only_id: '',
    servicer: '',
    mobile: '',
    phone_num: ''
  }

  serachHandle() {
    this.getServiceList();
  }

  serachCleanHandle() {
    this.formSearch = {
      only_id: '',
      servicer: '',
      mobile: '',
      phone_num: ''
    };
    this.getServiceList();
  }
  // --------------搜索--------------
  // --------------列表--------------
  private listLoading = false;
  private serviceList: any[] = [];

  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }

  private handleCurrentChange(size:number) {
    this.pagination.currentPage = size;
    this.getServiceList();
  }

  private handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getServiceList();
  }

  private getServiceList() {
    this.listLoading = true;
    var params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      ...this.formSearch,
    };

    getServiceList(params).then(res => {
      const data = res.data;
      if (data !== null) {
        this.pagination.total = parseInt(data.count);
        this.serviceList = data.list;
      } else {
        this.pagination.total = 0;
        this.serviceList = [];
      }
      this.listLoading = false;
    }).catch(err => {
      this.listLoading = false;
      this.pagination.total = 0;
      this.serviceList = [];
      let msg = err.msg;
    });
  }
  // --------------列表--------------
  // --------------二维码--------------
  private qrFlge = false;

  private formCode: any = {
    servicer: '',
    customer: '',
    qrCode: '',
    a: '',
    b: ''
  }

  detailHandle(val:any) {
    this.qrFlge = true;
    this.formCode.servicer = val.short_name !== '' ? val.short_name : val.servicer_company_name;
    this.formCode.customer = UserModule.getCompanyShortName !== '' ? UserModule.getCompanyShortName : UserModule.getCompanyName;
    QRCode.toDataURL(val.qr_str)
      .then((url : any) => {
        this.formCode.qrCode = url;
      })
      .catch((err : any) => {
        let msg = err;
      });
  }

  // 下载二维码
  handleDownload() {
    let code = document.querySelector('#qrCodeServiceid');
    let filename = '';
    html2canvas(code as any).then(function(canvas:any) {
      let image = new Image();
      image.src = canvas.toDataURL('image/png');
      let a = document.createElement('a');
      a.appendChild(image);
      a.href = image.src;
      a.download = filename;
      a.click();
    });
  }
  close() {
    this.qrFlge = false;
    this.formCode = {
      servicer: '',
      customer: '',
      qrCode: ''
    };
  }
  // --------------二维码--------------
  // --------------删除--------------
  deleteHandle(val:any) {
    if (val.create_source !== 2) {
      this.$confirm('是否删除服务方', '', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteServicer(val.sid);
      }).catch(() => {

      });
    } else {
      this.showErrorMsg('此服务方不能删除');
    }
  }
  deleteServicer(relationId:string) {
    let p = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      relation_id: relationId
    };
    deleteService(p).then(res => {
      this.showSecussMsg('删除成功');
      this.getServiceList();
    }).catch(err => {
      let msg = err.msg;
    });
  }
  // --------------删除--------------
  // --------------添加--------------6d7078 638517  6a1a4f
  private addServicerFlge = false
  private addServicerForm: object = {
    only_id: '',
    marke: ''
  }
  private rules = {
    only_id: [
      { required: true, message: '请输入唯一ID', trigger: 'blur' }
    ] }
  addServicerHandle() {
    this.addServicerFlge = true;
  }

  addServicer() {
    (this.$refs.ruleForm as any).validate((valid: any) => {
      if (valid) {
        let p = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId,
          type: '1',
          ...this.addServicerForm

        };
        addService(p).then(res => {
          this.addServicerFlge = false;
          this.showSecussMsg('添加成功');
          this.getServiceList();
          this.closeAddServer();
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
      } else {
        return false;
      }
    });
  }
  closeAddServer() {
    this.addServicerFlge = false;
    this.addServicerForm = {
      only_id: '',
      marke: ''
    };
  }
  // --------------添加--------------
  created() {
    this.getServiceList();
  }

  showErrorMsg(msg:string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }

  showSecussMsg(msg:string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
